import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_RISORSE_PERMESSO_PUBBLICO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IRisorsePermessoPubblicoState extends EntityState<IID_RISORSE_PERMESSO_PUBBLICO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_RISORSE_PERMESSO_PUBBLICO , realtimeEntity: 'IID_RisorsePermessoPubblico'})
@InterfaceDataStore(InterfaceName.RISORSE_PERMESSO_PUBBLICO)
export class IIDRisorsePermessoPubblicoStore extends EntityStore<IRisorsePermessoPubblicoState> {
  constructor() {
    super();
  }
}
